import { createReducer,on } from '@ngrx/store';

//import { initialClientState } from "../models/statemodels/app-state.model";
import { fetchClient, updateClient } from '../actions/client.action';


export const initialClientState ={
    payload: {}
  }

export const _clientReducer = createReducer(initialClientState,
        on(fetchClient, (state,action) => {
            return {
                ...state,
                payload: action.payload,
                lastAction:'fetchClient'
            }
        }),
        on(updateClient, (state,action) => {
            return {
                ...state,
                payload: action.payload,
                lastAction:'updateClient'
            }
        })
);


export function clientReducer(state,action){

    switch(action.type){
        case 'fetchClient':{
            console.log("inside fetchClient");
            return _clientReducer(state,action)
        }
        case 'updateClient':{
            console.log("inside updateClient");
            return _clientReducer(state,action)
        }
        default :{
            console.log('Inside default block');
            return state;
        }
    }
    
}
